<template>
  <DialogTemplateWithFooterToolkit
    v-if="tender.biddingType && (tender.biddingType.showSubscribedUsers || tender.biddingType.isPublic)"
    :dialog="dialog"
    dialog_class="subscribed-to-category"
    :label="tender.additionalCategories && tender.additionalCategories.length
      ? $t('Tenders.AllSubscribersForSomeCats') : $t('Tenders.AllSubscribers') "
    @close="dialog = false">
    <AllSubscribers
      slot="activator"
      :categories="tender.additionalCategories"
      :class="{'subscribed-to-category-activator': !$can('hide', 'InvitedListSearchDialog')}"
      :main_category="tender.category"
      :subscribers-count="subscribersUsers.length"
      @click="open"/>
    <template #actions>
      <sInput
        class="serach_field pa-0 my-4"
        :placeholder="$t('Tenders.EnterVendorName')"
        prefix-icon="search"
        :value.sync="search"
        @change="applySearch"
        @keydown_enter.prevent="applySearch"
        @paste="applySearch"/>
    </template>
    <template #card_text>
      <MembersTable
        class="mb-4"
        :expanded.sync="expanded"
        hide_select
        inf_selector=".subscribed-to-category .wrapper .members-table .v-data-table__wrapper"
        item_key="unigueKey"
        :items="computed_items"
        :orgs_headers="headers"
        :users_headers="expand_headers"
        @expandRow="expandRow"/>
    </template>
    <template #second_col>
      <sButton
        key="footer-button"
        @click="dialog = false">
        {{ $t(`Common.Close`) }}
      </sButton>
    </template>
  </DialogTemplateWithFooterToolkit>
</template>
<script>
import MembersTable from 'components/tenders/MembersTable.vue'
import AllSubscribers from 'components/tenders/AllSubscribers.vue'
import DialogTemplateWithFooterToolkit from 'components/common/dialogs/DialogTemplateWithFooterToolkit.vue'


import { tenderMixin } from 'mixins'
import { debounce } from 'toolkit/utils/util'

export default {
  name: 'subscribedToCategory',
  mixins: [ tenderMixin ],
  data() {
    return {
      dialog: false,
      search: '',
      items: [],
      computed_items: [],
      expanded: []
    }
  },
  props: {
    subscribedToCategory: Array,
    tender: Object,
  },
  computed: {
    headers() {
      const result = [
        {text: this.$t('Tenders.Company'), value: 'organizationTitle'},
        {text: this.$t('Tenders.EDRPOU'), value: 'organizationUsreou', sortable: false, width: '138px' },
        {text: this.$t('Tenders.Rating'), value: 'supplierRatings', width: '115px'},
        {text: '', value: 'count', sortable: false, width: '50px'},
      ]
      return result
    },
    expand_headers() {
      const result = [
        {text: '', value: '', width: '10px' },
        {text: '', value: 'userConcatNameEmail' },
        {text: '', value: 'empty', sortable: false, width: '50px'},
      ]

      return result
    },
    subscribersUsers() {
      return this.$_getSubscribersUseers()
    },
  },
  methods: {
    open() {
      if (this.$can('hide', 'InvitedListSearchDialog')) {
        return
      }
      this.$set(this, 'items', this.subscribedToCategory
        .map((elem, index) =>
          Object.assign(
            {},
            {
              ...elem,
              unigueKey: `${elem.organizationUsreou}_${index}`,
              count: elem.count || elem.users?.length
            }
          )
        ))
        .sort((a,b) => b.participationCount - a.participationCount || a.organizationTitle?.localeCompare(b.organizationTitle))

      this.$set(this, 'computed_items', this.items.slice(0))
      this.dialog = true

    },
    applySearch: debounce(function () {
      this.computed_items = this.items.slice(0).filter(this.$_filterMembersBySearch)
    }, 250),
    expandRow (item) {
      item.expanded = !item.expanded
      this.expanded = this.computed_items.filter(el => el.expanded )
    },
  },
  components: {
    MembersTable,
    AllSubscribers,
    DialogTemplateWithFooterToolkit,
  }
}
</script>
<style lang="scss" scoped>
.subscribed-to-category-activator {
  cursor: pointer;
}
</style>
<style lang="scss">
.subscribed-to-category {
  #members-table
  {
    .members-table .v-data-table__wrapper{
    // max-height: unset;
      max-height: calc(90vh - 425px);
    }
  }
}
</style>
